import { CommonModule } from "@angular/common";
import { Component, computed, input, output } from "@angular/core";
import { AudioStreamComponent } from "@components/audio-stream/audio-stream";

@Component({
  selector: "app-audio-transcriber",
  standalone: true,
  imports: [CommonModule, AudioStreamComponent],
  template: `
    <div [class]="audioTranscriberClasses()" data-testid="audio-transcriber">
      <app-audio-stream [audioFileName]="audioFile()" [disabled]="disabled()" (playAudio)="playAudio.emit()" />

      <input
        class="audio-transcriber__input"
        type="text"
        autocapitalize="none"
        label="Écris ce que tu entends"
        name="audio-exercise-answer"
        aria-label="Veuillez entrer un homophone"
        placeholder="Homophone"
        maxlength="27"
        autocomplete="off"
        [value]="value()"
        (input)="handleOnInput($event)"
        [disabled]="disabled()"
        data-lpignore="true"
      />
    </div>
  `,
  styles: [
    `
      @use "responsive" as *;

      .audio-transcriber__container {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        height: 61px;
        padding: 10px;
        flex-shrink: 0;
        box-sizing: border-box;
        border-radius: 20px;

        border: 2px solid #d1dde0;
        background: #ffffff;
        box-shadow: 0 4px 0 0 #d1dde0;

        &.is-correct {
          border-color: #05bf8e;
          background-color: #cdf2e8;
          box-shadow: 0 4px 0 0 #05bf8e;
        }

        &.is-incorrect {
          border-color: #ff3614;
          background-color: #ffcfb1;
          box-shadow: 0 4px 0 0 #ff3614;
        }

        &.is-disabled {
          cursor: not-allowed;
        }
      }

      .audio-transcriber__input {
        width: 122px;
        height: 45px;
        padding: 0 16px 0 8px;
        border: none;
        border-radius: 16px;
        background-color: #f5f3ef;
        font-size: 1.6rem;
        font-weight: 500;
        outline: none;

        @include screenWidth("to-mobile-small") {
          width: 120px;
          padding-right: 8px;
        }

        &:focus {
          outline: none;
          box-shadow: 0 0 0 4px #e7e1d8;
        }

        &:disabled {
          cursor: not-allowed;
        }
      }

      input:focus::placeholder {
        color: transparent;
      }

      input:focus::-webkit-input-placeholder {
        color: transparent;
      } /* Chrome, Safari */
      input:focus:-moz-placeholder {
        color: transparent;
      } /* Firefox 4-18 */
      input:focus::-moz-placeholder {
        color: transparent;
      } /* Firefox 19+ */
      input:focus:-ms-input-placeholder {
        color: transparent;
      } /* IE 10+ */
    `,
  ],
})
export class AudioTranscriptionComponent {
  audioFile = input<string>("");
  value = input.required<string>();
  disabled = input<boolean>();
  class = input<string>("");

  playAudio = output<void>();

  audioTranscriberClasses = computed(() => {
    const classes = ["audio-transcriber__container"];

    if (this.class() && this.class() !== "") {
      classes.push(this.class());
    }

    if (this.disabled()) {
      classes.push("is-disabled");
    }

    return classes.join(" ");
  });

  changeValue = output<string>();

  protected handleOnInput(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    this.changeValue.emit(value);
  }
}
